module.exports = __webpack_public_path__ + "static/media/usa-laoshi4.f2984bfa.jpg";